import { render, staticRenderFns } from "./examEntrance.vue?vue&type=template&id=2a7eaa66&scoped=true"
import script from "./examEntrance.vue?vue&type=script&lang=js"
export * from "./examEntrance.vue?vue&type=script&lang=js"
import style0 from "./examEntrance.vue?vue&type=style&index=0&id=2a7eaa66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7eaa66",
  null
  
)

export default component.exports